export const sentimentColors = [
  ['rgba(128,196,245,0.9)', '#006CE2'],
  // ['rgba(255,255,255,0.9)', 'rgba(172,172,172,0.9)'],
];

export const defaultSentimentChartOption = {
  chart: {
    type: 'solidgauge',
    // className: 'solid-chart',
    width: 160,
    height: 240,
  },
  // title: {
  //   useHTML: true,
  //   text: '1111',
  //   // align: 'center',
  //   style: {
  //     color: '#DBDBDB',
  //     fontSize: '.875rem',
  //     fontFamily: 'Helvetica Neue, Arial, sans-serif',
  //     fontWeight: 500,
  //     background: 'none',
  //     textAlign: 'center',

  //     // marginTop: '0.625rem',
  //   },
  //   // y: '-40%',
  //   width: 120,
  //   widthAdjust: 0,
  //   x: 50,

  //   // margin: 20,
  // },
  title: null,
  credits: {
    enabled: false,
  },
  lables: null,
  tooltip: {
    enabled: false,
  },
  pane: {
    size: '100%',
    startAngle: 0,
    endAngle: 360,
    background: [
      {
        // Track for Move
        outerRadius: '100%',
        innerRadius: '90%',
        backgroundColor: '#303030',
        borderWidth: 0,
      },
      {
        // Track for Exercise
        outerRadius: '85%',
        innerRadius: '75%',
        backgroundColor: '#303030',
        borderWidth: 0,
      },
    ],
  },
  yAxis: {
    min: 0,
    max: 100,
    lineWidth: 0,
    tickPositions: [],
  },
  plotOptions: {
    solidgauge: {
      dataLabels: {
        useHTML: true,
        align: 'center',
        borderWidth: 0,
        style: {
          color: '#FFFFFF!important',
          fontFamily: 'Helvetica Neue, Arial, sans-serif',
          fontWeight: 'normal',
        },
        verticalAlign: 'middle',
      },
      tooltip: {
        followPointer: true,
      },
      linecap: 'round',
      stickyTracking: false,
      rounded: true,
      className: 'solid-style',
    },
  },
  series: [
    {
      name: 'Target',
      data: [
        {
          color: sentimentColors[0][0],
          radius: '100%',
          innerRadius: '90%',
          dataLabels: {
            enabled: true,
            align: 'center',
            verticalAlign: 'middle',
            formatter() {
              return `<span style="font-size:0.75rem!important;">${this.series.name}  </span><span style="font-size:1.25rem!important;font-weight:bold !important;;">   ${this.y}</span>`;
            },

            y: 100,
          },
        },
      ],
    },
    {
      name: 'Buyer',
      data: [
        {
          color: sentimentColors[0][1],
          radius: '85%',
          innerRadius: '75%',
          dataLabels: {
            // useHTML: true,
            enabled: true,
            align: 'center',
            verticalAlign: 'middle',
            formatter() {
              return `<span style="font-size:0.75rem!important;">  ${this.series.name} </span><div style="font-size:1.25rem!important;font-weight:bold;">   ${this.y}</div>`;
            },
          },
        },
      ],
    },
  ],
};

export const YEARS_NEED_STACKLABEL = ['Y1', 'Y3'];
